type JsonLdScript = {
  readonly type: 'application/ld+json'
  readonly innerHTML: string
}

// unhead 2 (Nuxt 4) не поддерживает ключ `children` для содержимого тега: он молча
// становится HTML-атрибутом, а сам <script> остаётся пустым. `<` экранируется, чтобы
// текст из CMS с `</script>` не мог закрыть тег раньше времени; JSON при этом валиден.
export const jsonLdScript = (data: Record<string, unknown>): JsonLdScript => ({
  type: 'application/ld+json',
  innerHTML: JSON.stringify(data).replace(/</g, '\\u003c'),
})
